var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getLatestImports } from '@sonar-software/sonar-imports';
import { LoadingSonar } from '@ui/icons/LoadingSonar';
import { OrganizationTypeId } from '@sonar-software/sonar-ts-types';
import { COPY_SPECIFIC, ImportStatus } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useInterval, useOnMount } from '@hooks';
function getLatestPardotImport() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const result = yield getLatestImports({
            count: 1,
            organizationTypeId: OrganizationTypeId.Pardot
        });
        const latestImports = (_a = result.data) !== null && _a !== void 0 ? _a : [];
        return latestImports.length ? latestImports[0] : undefined;
    });
}
export const PardotSync = () => {
    const [inProgress, setInProgress] = useState(false);
    const refresh = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const latestImport = yield getLatestPardotImport();
        if (!latestImport ||
            latestImport.status === ImportStatus.Completed ||
            latestImport.status === ImportStatus.Failed) {
            setInProgress(false);
            return;
        }
        setInProgress(true);
    }), []);
    useOnMount(() => {
        refresh();
    });
    useInterval(() => {
        refresh();
    }, 5000);
    if (!inProgress) {
        return null;
    }
    return React.createElement(LoadingSonar, { tooltip: COPY_SPECIFIC.PARDOT_IS_SYNCING });
};
